import type { DisplayCurrency } from '@/shared/api/experience';
import type { CurrencyCode } from '@/shared/lib/currency';
import type { DisplayCurrencyIso } from '@/shared/types/displayCurrency';

export enum Sort {
  popularity = 'rank',
  publishedAt = 'published_at',
  price = 'price',
  rating = 'rating',
  discount = 'discount',
}

export interface TDisplayCurrencyData {
  code: CurrencyCode;
  symbol: string;
  iso: DisplayCurrencyIso;
  currencies: DisplayCurrency[];
}
